module.exports = __webpack_public_path__ + "img/ensuranceService.4ce28f5a.svg";